import { FormieFormTheme } from '@/lib/formie-theme.js';

document.addEventListener('onFormieInit', (e) => {
    if (!e?.detail?.form) return;

    const formie = e.detail.form;
    formie.theme = new FormieFormTheme(formie.$form, formie.config);
});
